import request from './index';

export function linkus(file) {
  return request.post('officialMessage/add', file, {});
}

